const DATA_TEST_IDS = {
  moduleAddModuleButton: 'module__add-module-button',
} as const;

export default DATA_TEST_IDS;
